// React
import React from "react";
import classNames from "classnames";
// Domain
import * as userDomain from "user/user/User";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./ContextSelection.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class ContextSelection extends React.Component {
    render() {
        let { user, officeId, officeName, agencyId, agencyName, expanded } = this.props;
        const renderMoreOptions = (isExpanded) => {
            if (user.userAccess.length <= 1) {
                return React.createElement("span", null);
            }
            else if (isExpanded) {
                return React.createElement("span", { className: "glyphicon glyphicon-menu-up", "aria-hidden": "true" });
            }
            else {
                return React.createElement("span", { className: "glyphicon glyphicon-menu-down", "aria-hidden": "true" });
            }
        };
        const renderOffice = () => {
            return (React.createElement("div", { className: classNames(styles.officeSelector, styles.officeContext, !this.props.menuExpanded && styles.collapsed) },
                React.createElement("div", { className: styles.agency }, agencyName),
                React.createElement("div", { className: styles.office }, officeName),
                renderMoreOptions(expanded)));
        };
        const renderAgency = () => {
            return (React.createElement("div", { className: classNames(styles.officeSelector, styles.agencyContext, !this.props.menuExpanded && styles.collapsed) },
                React.createElement("div", { className: styles.agency }, agencyName),
                renderMoreOptions(expanded)));
        };
        const renderUnselected = () => {
            let displayText = "Select an Office";
            if (user.userAccess.some((item) => item.type == userDomain.EntryType.Agency)) {
                displayText += " / Agency";
            }
            return (React.createElement("div", { className: classNames(styles.officeSelector, styles.unselectedContext) },
                React.createElement("div", { className: styles.unselected }, displayText),
                renderMoreOptions(expanded)));
        };
        if (officeId) {
            return renderOffice();
        }
        else if (agencyId) {
            return renderAgency();
        }
        else {
            return renderUnselected();
        }
    }
}
